<template>
  <div
    data-test="overlay"
    class="fixed h-screen w-full bg-black/60"
  />
</template>
